import { useQuery } from "@tanstack/react-query";
import { refreshToken } from "../services";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../constants";

export const useRefreshToken = () => {
  let token = localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT);

  const {
    isLoading: refreshingToken,
    isError: errorRefreshingToken,
    refetch: RefetchRefreshToken,
    data: newToken,
  } = useQuery({
    queryKey: ["refreshToken"],
    queryFn: async () => {
      const newToken = await refreshToken(token); // Extend the token and obtain the new token
      return newToken; // Return the new token
    },
    refetchInterval: false,
    refetchIntervalInBackground: false,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: (newToken) => {
      localStorage.setItem(AUTHENTICATED_EMPLOYEE_JWT, newToken);
      token = newToken;
    },
  });

  return { refreshingToken, errorRefreshingToken, RefetchRefreshToken, newToken };
};
